import { useMemo } from 'react'
import type { SchemaGeneratorState } from '@/api/types/schema'
import { validateSchemaGeneratorState } from '@/utils/schema/schema-utils'

export function useSchemaValidation(state: SchemaGeneratorState) {
  return useMemo(() => {
    return validateSchemaGeneratorState(state)
  }, [state])
}
